import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';
import { TrashIcon } from '@contra/icons/icons';
import { useCallback } from 'react';

type RecoverUnsavedChangesModalProps = CommonTemplateProps & {
  readonly onDiscardChanges: () => void;
  readonly onRecoverChanges: () => void;
};

export const RecoverUnsavedChangesModal = ({
  closeModal,
  isOpen,
  onDiscardChanges,
  onRecoverChanges,
}: RecoverUnsavedChangesModalProps) => {
  const handleDiscardChanges = useCallback(() => {
    onDiscardChanges();
    closeModal();
  }, [closeModal, onDiscardChanges]);

  const handleRecoverChanges = useCallback(() => {
    onRecoverChanges();
    closeModal();
  }, [closeModal, onRecoverChanges]);

  const heading = 'Recover unsaved changes?';

  return (
    <ModalTemplateWrapper
      ariaLabel={heading}
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleRecoverChanges,
          label: 'Recover changes',
          variant: 'V2Primary',
        },
        secondaryCTA: {
          handleOnClick: handleDiscardChanges,
          icon: TrashIcon,
          label: 'Discard and start over',
          variant: 'V2DestructiveLink',
        },
      }}
      desktopModalSize="md"
      headerText={heading}
      isOpen={isOpen}
      onClose={handleDiscardChanges}
      subheaderText={
        <>
          Pick up where you left off by recovering unsaved changes.
          <br />
          Otherwise, discard changes to start from scratch.
        </>
      }
    />
  );
};
